import React from 'react';
import { Grid, Typography, Box, Item } from '@mui/material';
import SubMainLobyComponent from './subMainLobyComponent';
import './mainStyles.css';

const LobyComponent = (props) => {
    const { Component } = props;
    return (
        <div className="mainDiv">
            <div className="subGrid">
                <div style={{ background: "black", overflowY: 'hidden', width: '100%' }}>
                    <SubMainLobyComponent />
                </div>
                <div style={{ background: "white", overflowY: 'scroll', height: '100vh', width: '100%' }}>
                    <Component />
                    <div style={{
                        position: 'absolute',
                        bottom: '10%',
                        right:'5%',
                        //left: '70%',
                        flexDirection: 'row'
                    }}>
                        <a href="" style={{ color: '#000000', display: "inline", textDecoration: 'none' }}>{`Copyright ©2022 Akos `}</a>
                        <a href="" style={{
                            color: '#000000', display: "inline", textDecoration: 'none'
                        }}>| All Rights Reserved</a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LobyComponent;